<template>
    <b-modal
        id="test-preview-modal"
        dusk="preview-test-modal"
        :title="test?.title"
        :ok-title="$t('common.close')"
        ok-only
        hide-footer
        size="lg"
        modal-class="apprentice-default-modal"
        ref="test-preview-modal">
        <div class="test-wrapper">
            <b-alert
                class="w-100"
                show
                variant="warning">
                {{ $t('testcenter.preview_warning_message') }}
            </b-alert>

            <p class="test-description"
               v-if="currentQuestionIndex === 0">
                {{ test?.description }}
            </p>

            <p class="question-count"
               v-if="currentQuestion">
                {{
                    $t('testcenter.question_current_of_total', {
                        current: currentQuestionIndex,
                        total: test?.questions.length
                    })
                }}
            </p>

            <div v-if="currentQuestion">
                <b-progress
                    class="test-progress"
                    variant="primary"
                    :value="currentQuestionIndex"
                    :max="test?.questions.length"></b-progress>

                <p class="question-text">{{ currentQuestion.text }}</p>

                <ul class="answers">
                    <li
                        class="answer"
                        v-for="option in options"
                        :key="option.key">
                        <b-form-radio
                            class="apprentice-radiobutton"
                            :disabled="true">
                            {{ option.text }}
                        </b-form-radio>
                    </li>
                </ul>
            </div>

            <div class="question-controls">
                <b-button
                    v-if="currentQuestion"
                    class="btn-previous"
                    variant="outline-primary"
                    @click="handlePreviousButton"
                    dusk="previous-button">
                    {{ $t('common.previous') }}
                </b-button>

                <b-button
                    v-if="!testIsFinished"
                    class="btn-next"
                    variant="primary"
                    @click="handleNextButton"
                    dusk="next-button">
                    {{ currentQuestionIndex === 0 ? $t('testcenter.start') : $t('common.next') }}
                </b-button>
            </div>
        </div>

        <div
            class="question"
            v-if="testIsFinished"
            dusk="no-more-questions">
            <p class="test-description mb-3">
                {{ $t('testcenter.you_answered_all_questions') }}<br />
            </p>

            <div class="question-controls">
                <b-button
                    class="btn-previous"
                    variant="primary"
                    @click="handlePreviousButton"
                    dusk="previous-button">
                    {{ $t('common.previous') }}
                </b-button>
                <b-button
                    class="btn-next"
                    variant="primary"
                    @click="close"
                    dusk="close-test-preview">
                    {{ $t('common.close') }}
                </b-button>
            </div>
        </div>

    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-test-preview-modal-component',

    data() {
        return {
            test: null,
            currentQuestionIndex: 0,
            max: 100
        };
    },

    computed: {
        currentQuestion: function() {
            if (
                this.test === null ||
                this.currentQuestionIndex === 0 ||
                this.currentQuestionIndex > this.test?.questions.length
            ) {
                return null;
            }

            return this.test?.questions?.find((question) => question.index === this.currentQuestionIndex);
        },
        testIsFinished: function() {
            return this.currentQuestionIndex > this.test?.questions.length;
        },

        options: function() {
            if (!this.currentQuestion) {
                return [];
            }

            return this.currentQuestion.options;
        },

        title: function() {
            if (this.currentQuestionIndex === 0) {
                return this.test?.title;
            }

            return this.test?.title + ' - ' + this.$t('testcenter.question') + ' ' + this.currentQuestionIndex;
        }
    },

    methods: {
        show(test) {
            this.test = test;
            this.currentQuestionIndex = 0;
            this.$refs['test-preview-modal'].show();
        },

        handlePreviousButton() {
            if (this.currentQuestionIndex === 0) {
                return;
            }

            this.currentQuestionIndex -= 1;
        },

        handleNextButton() {
            if (this.currentQuestionIndex > this.test?.questions.length) {
                return;
            }

            this.currentQuestionIndex += 1;
        },

        close() {
            this.$refs['test-preview-modal'].hide();
        }
    }
};
</script>

<style scoped lang="scss"></style>
